import { i18n } from 'core/i18n'

// @components
import { OKButton } from 'components/commons/OKButton/OKButton'
import { Link } from 'react-router-dom';

// @helpers
import { taggingBuyCryptoAssets } from './helpers/cryptoAssetsHelper'
import { CONTRACT_CRYPTO_FLOW_URL } from './contants/cryptoAssetsConstants';

import './cryptoAssetsBanner.scss';

const { FormattedText } = i18n;

export const CryptoAssetsBanner = () => {
    return (
        <a href={CONTRACT_CRYPTO_FLOW_URL} className="crypto-assets-link" onClick={taggingBuyCryptoAssets}>
            <div className="crypto-assets">
                <div className='crypto-assets__content'>
                    <div className='crypto-assets__icon'>
                        <i className="icons icons--icon-crypto"></i>
                    </div>
                    <div className='crypto-assets__text'>
                        <FormattedText value="gp_crypto_asset-gp_crypto_asset_offer_description_text" />
                    </div>
                </div>
                <div>
                    <OKButton>
                        <FormattedText value="gp_crypto_asset-gp_crypto_asset_offer_description_cta" />
                    </OKButton>
                </div>
            </div>
        </a>
    );
}
